import React from 'react';
import { Divider as BeaconDivider, tokens, type DividerProps } from '@sighten/beacon';

export type TDividerProps = React.ComponentPropsWithRef<'hr'> &
  DividerProps & {
    /**
     * Optional maximum width for the divider
     */
    $maxWidth?: string;
    /**
     * Optional color
     */
    $lineColor?: string;
    /**
     * Optional thickness of the divider
     */
    $height?: string;
    /**
     * Optional margin
     */
    $margin?: string;
  };

export function Divider({
  $maxWidth,
  $lineColor = tokens.colors.global.background['interaction-pressed'].css,
  $height,
  $margin,
  style,
  tokens: propTokens,
  ...props
}: TDividerProps) {
  return (
    <BeaconDivider
      style={{ margin: $margin, maxWidth: $maxWidth, ...style }}
      tokens={{
        '--divider-stroke-color': $lineColor,
        '--divider-stroke-width': $height,
        ...propTokens,
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}

export default Divider;
